import clsx from "clsx";
import { type PropsWithChildren } from "react";

import { useMainScroll } from "@/hooks/useMainScroll";

export function StickyHeader({ children }: PropsWithChildren) {
  const { y: scrollY } = useMainScroll();

  return (
    <div
      className={clsx(
        "sticky top-0 z-50 shrink-0 bg-surface-background transition-shadow duration-300 ease-out",
        scrollY > 0 ? "shadow-2xs" : "shadow-none",
      )}
    >
      {children}
    </div>
  );
}
